// extracted by mini-css-extract-plugin
module.exports = {"case":"styles_case__3UqLN","content":"styles_content__u4QGO"};